import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import memoizeOne from 'memoize-one';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core';
import { Refresh as RefreshIcon, RemoveRedEye as ViewIcon } from '@material-ui/icons';
import { FHETable } from 'data/components';
import { Toastr } from 'data/common';
import tools from 'data/common/tools';
import { getSDM18MVRs } from '../../data/SDM18MVR/actions';

class SDM18MVR extends PureComponent {
    static propTypes = {
        initialized: PropTypes.bool.isRequired,
        getSDM18MVRs: PropTypes.func.isRequired,
        SDM18MVRs: PropTypes.object.isRequired,
        profile: PropTypes.object.isRequired,
        classes: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);
        const { initialized } = props;
        this.state = {
            loading: !initialized
        };
    }

    componentDidMount() {
        const { initialized } = this.props;
        if (!initialized) this.refreshSDM18MVRs();
    }

    /* NAVIGATION */
    navigateToDetail = rowData => {
        const { history } = this.props;
        return history.push({ pathname: `SDM18MVR/detail/${rowData.id}` });
    };

    /* ACTIONS */
    refreshSDM18MVRs = () => {
        const { getSDM18MVRs } = this.props;
        this.setState({ loading: true });
        return getSDM18MVRs()
            .catch(err => {
                const message = Translator.translateWithFallback(`api.message.${err.message ? err.message : err}`, 'api.message.default');
                Toastr.error(message);
            })
            .finally(() => {
                this.setState({ loading: false });
            });
    };

    /* RENDER */
    renderActions = memoizeOne(profile => {
        const { history } = this.props;
        const userRight = profile.getIn(['user_rights', history.environment], []);

        let actions = {
            row: [],
            toolbar: [
                {
                    icon: RefreshIcon,
                    tooltip: Translator.translate(`general.products.SDM18MVR.table.globalAction.refresh.tooltip`),
                    onClick: this.refreshSDM18MVRs
                }
            ]
        };
        if (profile.get('admin') || userRight.includes('SDM18MVRDetails')) {
            actions.row.push({
                icon: ViewIcon,
                tooltip: Translator.translate(`general.showDetail`),
                onClick: this.navigateToDetail
            });
        }
        return actions;
    });

    renderData = memoizeOne(SDM18MVRs => {
        let result = [];
        SDM18MVRs.map(SDM18MVR => {
            result.push({
                id: SDM18MVR.get('macAddress'),
                macAddress: SDM18MVR.get('macAddress')
                    .match(/.{1,2}/g)
                    .join(':'),
                addressIp: SDM18MVR.get('addressIp'),
                email: SDM18MVR.get('userEmail'),
                label: SDM18MVR.get('label'),
                state: SDM18MVR.getIn(['state'], false) ? Translator.translate(`general.${SDM18MVR.get('state')}`) : null,
                firmwareVersion: SDM18MVR.get('firmwareVersion'),
                usersList: SDM18MVR.get('usersList'),
                userMasterId: SDM18MVR.get('userMasterId')
            });
        });
        return result;
    });
    renderColumns = memoizeOne(profile => {
        const { classes, history } = this.props;
        return [
            {
                title: Translator.translate('general.table.column.macAddress'),
                name: 'macAddress',
                width: 150,
                customFilter: tools.filterMacAddress
            },
            {
                title: Translator.translate('general.table.column.label'),
                name: 'label',
                action: (profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes('SDM18MVRDetails')) && {
                    onClick: this.navigateToDetail,
                    tooltip: Translator.translate(`general.showDetail`)
                }
            },
            {
                title: Translator.translate('general.table.column.email'),
                name: 'email'
            },
            {
                title: Translator.translate('general.table.column.addressIp'),
                name: 'addressIp'
            },
            {
                title: Translator.translate('general.table.column.state'),
                name: 'state',
                render: (row, data, value) => {
                    if (!value) return null;
                    return (
                        <span className={value === Translator.translate('general.connected') ? classes.connected : classes.disconnected}>
                            {value}
                        </span>
                    );
                }
            },
            {
                title: Translator.translate('general.table.column.firmwareVersion'),
                name: 'firmwareVersion',
                customSort: tools.sortVersion
            }
        ];
    });
    render() {
        const { loading } = this.state;
        const { profile, SDM18MVRs, history } = this.props;

        return (
            <FHETable
                idTable="SDM18MVRList"
                columns={this.renderColumns(profile)}
                data={this.renderData(SDM18MVRs)}
                actions={this.renderActions(profile)}
                title={Translator.translate(`general.products.SDM18MVR.table.title`)}
                emptyDataSourceMessage={Translator.translate(`general.products.SDM18MVR.table.body.emptyDataSourceMessage`)}
                isLoading={loading}
            />
        );
    }
}

function mapStateToProps(state, props) {
    const { history } = props;
    const users = state.environments[history.environment].data.Users.get('list');
    let SDM18MVRs = state.environments[history.environment].data.SDM18MVR.get('list');
    SDM18MVRs = SDM18MVRs.map(SDM18MVR => {
        const masterId = SDM18MVR.getIn(['userMasterId'], '');
        return SDM18MVR.setIn(['userEmail'], users.getIn([masterId && masterId.toString(), 'email'], ''));
    });

    return {
        profile: state.data.user,
        SDM18MVRs,
        initialized: state.environments[history.environment].data.SDM18MVR.get('initialized')
    };
}
const styles = theme => ({
    connected: {
        color: theme.palette.success.main
    },
    disconnected: {
        color: theme.palette.error.main
    }
});

export default withRouter(
    connect(
        mapStateToProps,
        dispatch => bindActionCreators({ getSDM18MVRs }, dispatch)
    )(withStyles(styles, { withTheme: true })(SDM18MVR))
);



// WEBPACK FOOTER //
// ./environments/myfhe/scenes/SDM18MVR/index.js